// @flow
import React from "react";
import bem from "@justpark/helpers/src/bem/bem";
import PrimaryFilter from "../../../svg/filter.svg";
import SecondaryFilter from "../../../svg/search_filter.svg";

import "./filterIcon.scss";

type Props = {
  type: "primary" | "secondary",
  color: "primary" | "brand"
};

const FilterIcon = ({ type, color }: Props) => {
  const baseClass = "c-filter-icon";

  return type === "primary" ? (
    <PrimaryFilter className={bem(baseClass, null, { color })} />
  ) : (
    <SecondaryFilter className={bem(baseClass, null, { color })} />
  );
};
FilterIcon.defaultProps = {
  type: "primary",
  color: "primary"
};

export default FilterIcon;
